module.exports = __webpack_public_path__ + "img/コンピュータのしくみI_5_5_1.167dff6c.jpeg";